/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccountType } from './AccountType';
import {
    AccountTypeFromJSON,
    AccountTypeFromJSONTyped,
    AccountTypeToJSON,
} from './AccountType';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import type { ApplicationScope } from './ApplicationScope';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeFromJSONTyped,
    ApplicationScopeToJSON,
} from './ApplicationScope';
import type { Organisation } from './Organisation';
import {
    OrganisationFromJSON,
    OrganisationFromJSONTyped,
    OrganisationToJSON,
} from './Organisation';
import type { Role } from './Role';
import {
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
} from './Role';

/**
 * 
 * @export
 * @interface DatabaseContributor
 */
export interface DatabaseContributor {
    /**
     * 
     * @type {string}
     * @memberof DatabaseContributor
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContributor
     */
    reference?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContributor
     */
    readonly company?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContributor
     */
    readonly firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContributor
     */
    readonly lastName?: string;
    /**
     * 
     * @type {Array<ApplicationScope>}
     * @memberof DatabaseContributor
     */
    tenants?: Array<ApplicationScope>;
    /**
     * 
     * @type {Address}
     * @memberof DatabaseContributor
     */
    address?: Address;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContributor
     */
    readonly email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseContributor
     */
    readonly enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseContributor
     */
    readonly verified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseContributor
     */
    readonly freeOfCharge?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseContributor
     */
    readonly readOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseContributor
     */
    readonly gracePeriod?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof DatabaseContributor
     */
    readonly disabledDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DatabaseContributor
     */
    deactivationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DatabaseContributor
     */
    deletionNotificationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DatabaseContributor
     */
    readonly deletionDate?: Date;
    /**
     * 
     * @type {AccountType}
     * @memberof DatabaseContributor
     */
    accountType?: AccountType;
    /**
     * 
     * @type {Array<Role>}
     * @memberof DatabaseContributor
     */
    readonly roles?: Array<Role>;
    /**
     * 
     * @type {Organisation}
     * @memberof DatabaseContributor
     */
    organisation?: Organisation;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseContributor
     */
    active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof DatabaseContributor
     */
    accessed?: Date;
}

/**
 * Check if a given object implements the DatabaseContributor interface.
 */
export function instanceOfDatabaseContributor(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseContributorFromJSON(json: any): DatabaseContributor {
    return DatabaseContributorFromJSONTyped(json, false);
}

export function DatabaseContributorFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseContributor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'reference': !exists(json, 'reference') ? undefined : json['reference'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'tenants': !exists(json, 'tenants') ? undefined : ((json['tenants'] as Array<any>).map(ApplicationScopeFromJSON)),
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'verified': !exists(json, 'verified') ? undefined : json['verified'],
        'freeOfCharge': !exists(json, 'freeOfCharge') ? undefined : json['freeOfCharge'],
        'readOnly': !exists(json, 'readOnly') ? undefined : json['readOnly'],
        'gracePeriod': !exists(json, 'gracePeriod') ? undefined : json['gracePeriod'],
        'disabledDate': !exists(json, 'disabledDate') ? undefined : (new Date(json['disabledDate'])),
        'deactivationDate': !exists(json, 'deactivationDate') ? undefined : (new Date(json['deactivationDate'])),
        'deletionNotificationDate': !exists(json, 'deletionNotificationDate') ? undefined : (new Date(json['deletionNotificationDate'])),
        'deletionDate': !exists(json, 'deletionDate') ? undefined : (new Date(json['deletionDate'])),
        'accountType': !exists(json, 'accountType') ? undefined : AccountTypeFromJSON(json['accountType']),
        'roles': !exists(json, 'roles') ? undefined : ((json['roles'] as Array<any>).map(RoleFromJSON)),
        'organisation': !exists(json, 'organisation') ? undefined : OrganisationFromJSON(json['organisation']),
        'active': !exists(json, 'active') ? undefined : json['active'],
        'accessed': !exists(json, 'accessed') ? undefined : (new Date(json['accessed'])),
    };
}

export function DatabaseContributorToJSON(value?: DatabaseContributor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'reference': value.reference,
        'tenants': value.tenants === undefined ? undefined : ((value.tenants as Array<any>).map(ApplicationScopeToJSON)),
        'address': AddressToJSON(value.address),
        'deactivationDate': value.deactivationDate === undefined ? undefined : (value.deactivationDate.toISOString()),
        'deletionNotificationDate': value.deletionNotificationDate === undefined ? undefined : (value.deletionNotificationDate.toISOString()),
        'accountType': AccountTypeToJSON(value.accountType),
        'organisation': OrganisationToJSON(value.organisation),
        'active': value.active,
        'accessed': value.accessed === undefined ? undefined : (value.accessed.toISOString()),
    };
}

